import classNames from 'classnames';
import React, { FC, useEffect, useState } from 'react';
import { BreakPoint, useScreenSize } from '../../components/ScreenSize';

import styles from './NewsType.module.scss';

interface Props {
  typeTitle?: string;
  typeList: Array<any>;
  currentTagName?: string;
  onChange(type: number | null): void;
}
const NewsType: FC<Props> = (props) => {
  const { typeTitle, typeList, onChange, currentTagName = '全部' } = props;
  const [currentTag, setCurrentTag] = useState<string>(currentTagName);
  // 获取新闻
  const getNews = (name: string, val: number) => {
    setCurrentTag(name);
    onChange(val);
  };
  const { screen } = useScreenSize();
  const isMobile = screen === BreakPoint.md || screen === BreakPoint.sm;

  useEffect(() => {
    setCurrentTag(currentTagName);
  }, [currentTagName]);

  useEffect(() => {
    if (isMobile) {
      document.getElementById(currentTagName)?.scrollIntoView({
        block: 'end',
      });
    }
  }, [isMobile, currentTagName]);

  return (
    <section className={styles['news-type-box']}>
      <div className={styles['news-type-title']}>{typeTitle}</div>
      <div className={styles['news-type-list-box']}>
        <div className={styles['news-type-list-wrap']}>
          {typeList?.map((item, index) => {
            return (
              <div
                id={item.typeName}
                className={classNames(styles['news-type-item'], {
                  [`${styles.activetag}`]: currentTag === item.typeName,
                })}
                key={index}
                onClick={() => {
                  getNews(item.typeName, item.typeVal);
                }}
              >
                {item.typeName}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
NewsType.defaultProps = {};

NewsType.displayName = 'NewsType';
export default NewsType;
